module.exports = __webpack_public_path__ + "static/img/c13.a31a28f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c13.png
// module id = 260
// module chunks = 0 1 2 3 4 5 6 7 8 9